import { ChangeDetectionStrategy, Component, effect, ElementRef, inject, input, untracked } from '@angular/core';
import { IProductDataV3 } from '@df/catalog/product/product';
import { AbIfDirective } from '@df/module-ab/ab-if.directive';
import { PricePipe } from '@df/ui/price/price.pipe';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ListingLabelComponent } from 'projects/app-default/src/app/common/listing-label/listing-label.component';
import { strapsUpsellCarouselAbConfig } from '../../../../../../basket/straps-upsell-carousel/basket-straps-upsell-carousel.component';
import { ProductPriceComponent } from '../../../../../../ui/price/product-price.component';
import { ProductDecorator } from '../../../../../model/product/product.decorator';
import { ProductLayoutDeliveryMessagesComponent } from '../../delivery/messages/product-layout-delivery-messages.component';
import { ProductLayoutComponent } from '../../product-layout.component';
import { NProductLayout } from '../../product-layout.interface';
import { ProductLayoutReviewsComponent } from '../../reviews/product-layout-reviews.component';
import { ProductLayoutWishlistComponent } from '../../wishlist/product-layout-wishlist.component';
import { ProductLayoutWishlistService } from '../../wishlist/product-layout-wishlist.service';
import { ProductLayoutWishlistToggleComponent } from '../../wishlist/toggle/product-layout-wishlist-toggle.component';

@Component({
    selector: 'product-layout-details-name',
    templateUrl: './product-layout-details-name.component.html',
    styleUrl: './product-layout-details-name.component.scss',
    imports: [
        AbIfDirective,
        ICmsClientModule,
        ListingLabelComponent,
        PricePipe,
        ProductLayoutDeliveryMessagesComponent,
        ProductPriceComponent,
        ProductLayoutReviewsComponent,
        ProductLayoutWishlistComponent,
        ProductLayoutWishlistToggleComponent,
        TranslatePipe
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductLayoutDetailsNameComponent extends UiComponent {
    readonly product = input.required<ProductDecorator<IProductDataV3>>();
    readonly content = input.required<NProductLayout.IContent>();
    readonly productViewLayout = input.required<ProductLayoutComponent>();

    readonly elementRef = inject(ElementRef<HTMLElement>);
    private readonly productLayoutWishlistService = inject(ProductLayoutWishlistService);

    constructor() {
        super();

        effect(() => {
            const _state = this.productLayoutWishlistService.state();

            untracked(() => {
                this.detectChanges();
            });
        });
    }

    get abShowCondition(): string {
        return `(${strapsUpsellCarouselAbConfig.experimentName}) ${strapsUpsellCarouselAbConfig.showFor}`;
    }
}
